// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"321":"2758fc68","352":"d6eb8e66","540":"1ecf3cab","808":"9bd612c0","843":"cb29df4b"}[chunkId] + ".css";
};